/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 *
 * Browser medya isteklerinin çağıran firma kapsamını kaynak türüne göre doğrular.
 * Bu değer yetki kanıtı değildir; API her isteği kimliği doğrulanmış aktöre göre yetkilendirir.
 */

type DmsMediaCallerScope = string | number | bigint | null | undefined;

export function resolveCompanyLogoMediaScopeId(companyId: DmsMediaCallerScope): string {
  const normalized = String(companyId ?? '').trim();
  return /^[1-9]\d*$/.test(normalized) ? normalized : '';
}

/** Sistem medyası çağrısında yalnız doğrulanmış SYSTEM veya BUSINESS kapsamını taşır. */
export function resolveSystemMediaCallerScopeId(companyId: DmsMediaCallerScope): string {
  const normalized = String(companyId ?? '').trim();
  return /^(?:0|[1-9]\d*)$/.test(normalized) ? normalized : '';
}

/** Kaynak türüne göre browser çağıran kapsamını çözer; SYSTEM yalnız sistem medyasında geçerlidir. */
export function resolveDmsMediaCallerScopeId(
  companyId: DmsMediaCallerScope,
  systemMedia = false,
): string {
  return systemMedia
    ? resolveSystemMediaCallerScopeId(companyId)
    : resolveCompanyLogoMediaScopeId(companyId);
}
